
export default {
  name: 'BoutiqueExerpt',
  props: {
    boutique: {
      type: Object,
      required: true
    }
  },
  computed: {
    img() {
      return this.boutique.content.carousel[0].Images[0]
    }
  }
}
